import React from 'react';

const LoadingFacts = () => {
  const sectionStyle = {
    marginBottom: '24px',
    padding: '20px',
    backgroundColor: '#f8fafc',
    borderRadius: '12px',
    border: '1px solid #e2e8f0',
    position: 'relative',
    overflow: 'hidden'
  };

  const shimmerStyle = {
    background: 'linear-gradient(90deg, #f8fafc 25%, #e2e8f0 50%, #f8fafc 75%)',
    backgroundSize: '200% 100%',
    animation: 'shimmer 1.5s infinite',
    borderRadius: '6px',
    height: '16px',
    marginBottom: '8px'
  };

  const pulseStyle = {
    animation: 'pulse 2s infinite'
  };

  return (
    <div style={{ padding: '20px' }}>
      {/* Add CSS animations */}
      <style>
        {`
          @keyframes shimmer {
            0% { background-position: -200% 0; }
            100% { background-position: 200% 0; }
          }
          
          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; }
          }
          
          @keyframes rotate {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}
      </style>

      {/* Header with spinner */}
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        marginBottom: '32px',
        padding: '20px'
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '4px solid #e2e8f0',
          borderTop: '4px solid #3b82f6',
          borderRadius: '50%',
          animation: 'rotate 1s linear infinite',
          marginRight: '16px'
        }}></div>
        <div>
          <h2 style={{ 
            margin: '0 0 4px 0',
            fontSize: '18px',
            fontWeight: '600',
            color: '#1f2937'
          }}>
            🤖 Extracting medical data...
          </h2>
          <p style={{
            margin: 0,
            fontSize: '14px',
            color: '#6b7280'
          }}>
            AI analysis of your transcription in progress
          </p>
        </div>
      </div>

      {/* Loading sections with new medical structure */}
      <div style={sectionStyle}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
          <div style={{
            width: '24px',
            height: '24px',
            backgroundColor: '#dbeafe',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '12px',
            ...pulseStyle
          }}>
            📅
          </div>
          <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#1f2937' }}>
            Consultation
          </h3>
        </div>
        <div style={{ ...shimmerStyle, width: '80%' }}></div>
        <div style={{ ...shimmerStyle, width: '60%' }}></div>
      </div>

      <div style={sectionStyle}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
          <div style={{
            width: '24px',
            height: '24px',
            backgroundColor: '#dbeafe',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '12px',
            ...pulseStyle
          }}>
            👤
          </div>
          <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#1f2937' }}>
            Patient
          </h3>
        </div>
        <div style={{ ...shimmerStyle, width: '75%' }}></div>
        <div style={{ ...shimmerStyle, width: '65%' }}></div>
      </div>

      <div style={sectionStyle}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
          <div style={{
            width: '24px',
            height: '24px',
            backgroundColor: '#dbeafe',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '12px',
            ...pulseStyle
          }}>
            👨‍⚕️
          </div>
          <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#1f2937' }}>
            Physician
          </h3>
        </div>
        <div style={{ ...shimmerStyle, width: '70%' }}></div>
        <div style={{ ...shimmerStyle, width: '55%' }}></div>
      </div>

      <div style={sectionStyle}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
          <div style={{
            width: '24px',
            height: '24px',
            backgroundColor: '#dbeafe',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '12px',
            ...pulseStyle
          }}>
            🎯
          </div>
          <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#1f2937' }}>
            Chief Complaint
          </h3>
        </div>
        <div style={{ ...shimmerStyle, width: '85%' }}></div>
        <div style={{ ...shimmerStyle, width: '70%' }}></div>
      </div>

      <div style={sectionStyle}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
          <div style={{
            width: '24px',
            height: '24px',
            backgroundColor: '#dbeafe',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '12px',
            ...pulseStyle
          }}>
            📋
          </div>
          <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#1f2937' }}>
            History of Present Illness
          </h3>
        </div>
        <div style={{ ...shimmerStyle, width: '90%' }}></div>
        <div style={{ ...shimmerStyle, width: '75%' }}></div>
        <div style={{ ...shimmerStyle, width: '65%' }}></div>
      </div>

      <div style={sectionStyle}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
          <div style={{
            width: '24px',
            height: '24px',
            backgroundColor: '#dbeafe',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '12px',
            ...pulseStyle
          }}>
            📚
          </div>
          <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#1f2937' }}>
            Past Medical History
          </h3>
        </div>
        <div style={{ ...shimmerStyle, width: '80%' }}></div>
        <div style={{ ...shimmerStyle, width: '90%' }}></div>
      </div>

      <div style={sectionStyle}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
          <div style={{
            width: '24px',
            height: '24px',
            backgroundColor: '#dbeafe',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '12px',
            ...pulseStyle
          }}>
            🩺
          </div>
          <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#1f2937' }}>
            Vital Signs
          </h3>
        </div>
        <div style={{ ...shimmerStyle, width: '70%' }}></div>
        <div style={{ ...shimmerStyle, width: '60%' }}></div>
      </div>

      <div style={sectionStyle}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
          <div style={{
            width: '24px',
            height: '24px',
            backgroundColor: '#dbeafe',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '12px',
            ...pulseStyle
          }}>
            🔍
          </div>
          <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#1f2937' }}>
            Examinations
          </h3>
        </div>
        <div style={{ ...shimmerStyle, width: '85%' }}></div>
        <div style={{ ...shimmerStyle, width: '75%' }}></div>
      </div>

      <div style={sectionStyle}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
          <div style={{
            width: '24px',
            height: '24px',
            backgroundColor: '#dbeafe',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '12px',
            ...pulseStyle
          }}>
            💊
          </div>
          <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#1f2937' }}>
            Prescription
          </h3>
        </div>
        <div style={{ ...shimmerStyle, width: '80%' }}></div>
        <div style={{ ...shimmerStyle, width: '70%' }}></div>
      </div>

      <div style={sectionStyle}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
          <div style={{
            width: '24px',
            height: '24px',
            backgroundColor: '#dbeafe',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '12px',
            ...pulseStyle
          }}>
            📝
          </div>
          <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#1f2937' }}>
            Conclusion
          </h3>
        </div>
        <div style={{ ...shimmerStyle, width: '75%' }}></div>
        <div style={{ ...shimmerStyle, width: '85%' }}></div>
      </div>
    </div>
  );
};

export default LoadingFacts;